import { getPricingForCompositionExtra } from '@koob/utils';

interface VersionPrice {
  price: number;
  currency?: string;
}

/**
 * Adds one priced piece to the running total of the version being compared.
 * Two currencies in one version cannot be summed: the total is flagged
 * `mismatch` and keeps adding.
 */
export function addToVersionTotal(
  prev: VersionPrice | null | undefined,
  piece: { price?: number | string; currency?: string } | null | undefined,
): VersionPrice {
  const prevCurrency = prev?.currency ?? '';
  const newCurrency = piece?.currency ?? prevCurrency;

  return {
    price: Number(prev?.price ?? 0) + Number(piece?.price ?? 0),
    currency:
      prevCurrency && newCurrency && prevCurrency !== newCurrency
        ? 'mismatch'
        : newCurrency,
  };
}

/**
 * The price an instance of an experience shows on its first day: the program
 * price, plus the extras the version recorded on THIS day. Later days of the
 * instance carry their extras only.
 */
export function priceVersionExperienceDay(
  pricing: any,
  {
    experienceDayIndex,
    extras,
    composition,
  }: { experienceDayIndex?: number; extras: any[]; composition: any },
): VersionPrice {
  const basePrice = experienceDayIndex === 1 ? (pricing?.price ?? 0) : 0;

  const extrasPrice =
    pricing?.extras?.reduce((total: number, extra: any) => {
      const isIncluded = extras.some((option) => option?.id === extra?.id);
      const priced = getPricingForCompositionExtra({
        composition,
        pricings: extra?.pricings,
      });

      return isIncluded ? total + (priced?.price ?? 0) : total;
    }, 0) ?? 0;

  return { price: basePrice + extrasPrice, currency: pricing?.currency };
}
